export const RTPS_HISTORY_SEARCH = 'rtpsHistorySearch';
export const RTPS_HISTORY_EXPORT = 'rtpsHistoryExport';
export const RTPS_METRICS = 'rtpsMetrics';
export const RTPS_STATISTICS = 'rtpsStatistics';



// WEBPACK FOOTER //
// ./src/store/rtps/rtps.actions.js